// Genereert/onthoudt een stabiele apparaat-id per browser (voor apparaatlimiet + activatielogboek).
export function getDeviceId() {
  let id = localStorage.getItem('mc_device_id');
  if (!id) {
    id = 'web-' + (window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36));
    localStorage.setItem('mc_device_id', id);
  }
  return id;
}
